import withDeviceInfo from 'ggApp/shared/components/viewport/withDeviceInfo';
import ReviewsWidget from './ReviewsWidget';

export default withDeviceInfo(ReviewsWidget);
